
export enum EventTextTypeModifiers {
    modifierLeague = "league",
    modifierEachWay = "each-way",
    modifierTeamName = "team-name",
    modifierEventName = "event-name",
    modifierEachWayEventName = "each-way-event-name"
}